import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ExecutiveSearchPage from "@/pages/ExecutiveSearchPage";
import CommercialLeadershipPage from "@/pages/CommercialLeadershipPage";
import TalentAdvisoryPage from "@/pages/TalentAdvisoryPage";
import PeoplePage from "@/pages/PeoplePage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/executive-search" element={<ExecutiveSearchPage />} />
          <Route path="/commercial-leadership" element={<CommercialLeadershipPage />} />
          <Route path="/talent-advisory" element={<TalentAdvisoryPage />} />
          <Route path="/people" element={<PeoplePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#15315F",
            border: "1px solid rgba(201,168,118,0.35)",
            color: "#fff",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
